// extracted by mini-css-extract-plugin
module.exports = {"highlightText":"TransUtil_highlightText__SOnLH","highlightTextVip":"TransUtil_highlightTextVip__2eeG6"};